import shortcutLaunchQuery from "~/pwa/shortcutLaunchQuery";

const isShortcutLaunch = (search: string = window.location.search): boolean =>
	search.replace(/^\?/, "").split("&").includes(shortcutLaunchQuery);

export default isShortcutLaunch;
